import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ToolFormTemplate } from '@/templates/BossBaby';
import { useBossBabyTools, useBossBabyToolDetail } from '@/hooks/useBossBaby';
import { UpdateBossBabyToolDto } from '@/dto/BossBabyDto';

export const ToolEdit: React.FC = () => {
  const navigate = useNavigate();
  const { toolId } = useParams<{ toolId: string }>();
  
  const { updateTool } = useBossBabyTools();
  const { tool, loading, fetchTool } = useBossBabyToolDetail(toolId || '');

  useEffect(() => {
    if (toolId) {
      fetchTool();
    }
  }, [toolId, fetchTool]);

  const handleSubmit = async (data: UpdateBossBabyToolDto) => {
    if (!toolId) return;
    
    try {
      await updateTool(Number(toolId), data);
    } catch (error) {
      console.error('Update tool error:', error);
    }
  };

  const handleCancel = () => {
    navigate('/boss-baby/tools');
  };

  if (!toolId) {
    return null;
  }

  return (
    <ToolFormTemplate
      initialData={tool || undefined}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      isEdit={true}
      loading={loading}
    />
  );
};